'use es6';

import { USERS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchUsersSearchPage, createGetUsersByIds, getUsersByIds, getUsersSearchPage } from 'reference-resolvers/api/UsersAPI';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { validateNumericId } from '../lib/validate';
export const createUserReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: USERS,
  idIsValid: validateNumericId,
  createFetchSearchPage: opts => createFetchUsersSearchPage(Object.assign({}, opts, {
    portalId: options === null || options === void 0 ? void 0 : options.portalId
  })),
  createFetchByIds: opts => createGetUsersByIds(Object.assign({}, opts, {
    portalId: options === null || options === void 0 ? void 0 : options.portalId
  })),
  fetchByIds: getUsersByIds,
  fetchSearchPage: getUsersSearchPage
}, options));
export default createUserReferenceResolver();